export default{
    checkLogin:function(){
          if(sessionStorage.getItem('Token')){
			  return true;
		  }else{
			  return false;
		  }
    }
}


// WEBPACK FOOTER //
// ./src/common/js/login.js